var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 15,
    viewBox: "0 0 10 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.47092 7.33404L3.36932 13.8715C3.23638 14.0139 3.02505 14.0508 2.85171 13.9618C2.67837 13.8729 2.58512 13.6797 2.62333 13.4886L3.42231 9.49376L0.282689 8.31641C0.146436 8.26531 0.0446712 8.14959 0.0114185 8.00792C-0.021838 7.86625 0.0178081 7.71733 0.117101 7.61095L6.2187 1.07352C6.35164 0.931093 6.56296 0.894197 6.73631 0.983155C6.90965 1.07211 7.00289 1.26531 6.96469 1.45636L6.16571 5.45123L9.30533 6.62858C9.44159 6.67967 9.54335 6.7954 9.5766 6.93707C9.60986 7.07874 9.57021 7.22765 9.47092 7.33404Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightning);
export default __webpack_public_path__ + "static/media/lightning.d00e3e1fe49e74bb18d6b5efa2e27bd8.svg";
export { ForwardRef as ReactComponent };